import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, assertUnreachable } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { Circle, Line } from 'react-shapes';

interface Props {
    texto: string
}

class EstadoNoRX extends React.PureComponent<Props> {

    render() {
        const { texto } = this.props;
        return (
            <div style={{ fontSize: 12, display: 'inline-block' }}>
                {this.props.texto}
            </div>
        );
    }
}
export const Estado = componentToRx(EstadoNoRX);

interface PropsItem {
    value: string;
    izq: boolean;
    der: boolean;
    incompleto?: boolean;
    cancelado?: boolean;
    icon: string;
}

class ContenedorEstados extends React.PureComponent<PropsItem> {
    render() {
        const x = this.props.value;
        const icon = this.props.icon;
        const izq = this.props.izq;
        const der = this.props.der;
        const color = this.props.incompleto ? 'white' : this.props.cancelado ? 'red' : '#FF8000';
        const colorCirculo = this.props.incompleto ? 'white' : this.props.cancelado ? 'red' : '#D85C34';
        const colorIcono = this.props.incompleto ? '#D85C34' : 'white';
        const bordeLinea = '#D85C34';

        return [
            <li style={{ width: '20%', height: 100, margin: 'auto' }}>

                <div style={{ display: 'flex', flexDirection: 'column' }} >

                    <div style={{ display: 'flex', flexGrow: 2, height: '70%', alignItems: 'center' }} >


                        {
                            izq &&
                            <div style={{ flex: '1 1 auto', height: '5px', background: color }} />
                        }

                        <div style={{ flex: '0 0 auto' }}>
                            <div style={{ width: '50px', height: '50px', background: colorCirculo, border: 'solid', borderColor: bordeLinea, borderRadius: '25px', textAlign: 'center', verticalAlign: 'middle', lineHeight: '50px' }}>
                                <span style={{ fontSize: 30, color: colorIcono }}>
                                    <i className={icon} > </i>
                                </span>
                            </div>
                        </div>

                        {
                            der &&
                            <div style={{ flex: '1 1 auto', height: '5px', background: color }} />
                        }


                    </div>

                    <div style={{ flexGrow: 1, height: '30%', verticalAlign: 'center' }}>

                        <div style={{ display: 'flex', flexDirection: 'row' }} >

                            {
                                izq &&
                                <div style={{ flex: '1 1 auto', height: '5px' }} />
                            }

                            <div style={{ flex: '0 0 auto', textAlign: 'center' }}>
                                <EstadoNoRX texto={x} />
                            </div>

                            {
                                der &&
                                <div style={{ flex: '1 1 auto', height: '5px' }} />
                            }

                        </div>

                    </div>

                </div>

            </li>
        ];
    }
}

interface Entidad {
    titulo: string;
    izq: boolean;
    der: boolean;
    incompleto?: boolean;
    cancelado?: boolean;
    icon: string;
}

class BarraEstadosNoRx extends React.PureComponent<{ value: Entidad[] }> {
    render() {
        const x = this.props.value;
        return (
            <ul style={{ display: 'flex', flexDirection: 'row', flexFlow: 'row wrap', height: 110, padding: 0, margin: 0, justifyContent: 'space-around', listStyle: 'none', }}>
                {
                    [
                        ...x.map((x, i) => <ContenedorEstados key={i} value={x.titulo} izq={x.izq} der={x.der} incompleto={x.incompleto} cancelado={x.cancelado} icon={x.icon} />)
                    ]
                }
            </ul>
        )
    }
}

export const BarraEstados = componentToRx(BarraEstadosNoRx);


export function statusToEstado(x: models.StatusGuia): Entidad[] {
    //TODO: Poner estos datos en diferentes variables para que no quede tan largo:
    switch (x) {
        case models.StatusGuia.ContenidoPendiente:
            return [
                {
                    titulo: "Documentado",
                    izq: false,
                    der: true,
                    icon: fa("file")
                },
                {
                    titulo: "En transito",
                    izq: false,
                    der: false,
                    incompleto: true,
                    icon: fa("truck")
                },
                {
                    titulo: "Sucursal de destino",
                    izq: false,
                    der: false,
                    incompleto: true,
                    icon: fa("bank")
                },
                {
                    titulo: "En entrega",
                    izq: false,
                    der: false,
                    incompleto: true,
                    icon: fa("train")
                },
                {
                    titulo: "Entregado",
                    izq: false,
                    der: false,
                    incompleto: true,
                    icon: fa("handshake-o")
                }
            ];

        case models.StatusGuia.EnVehiculoZE:
        case models.StatusGuia.EnCamionEAD:
            return [
                {
                    titulo: "Documentado",
                    izq: false,
                    der: true,
                    icon: fa("file")

                },
                {
                    titulo: "En transito",
                    izq: true,
                    der: true,
                    icon: fa("truck")
                },
                {
                    titulo: "Sucursal de destino",
                    izq: true,
                    der: true,
                    icon: fa("bank")
                },
                {
                    titulo: "En entrega",
                    izq: true,
                    der: true,
                    icon: fa("train")
                },
                {
                    titulo: "Entregado",
                    izq: false,
                    der: false,
                    incompleto: true,
                    icon: fa("handshake-o")
                }
            ];

        case models.StatusGuia.EnEmbarque:
            return [
                {
                    titulo: "Documentado",
                    izq: false,
                    der: true,
                    icon: fa("file")

                },
                {
                    titulo: "En transito",
                    izq: true,
                    der: true,
                    icon: fa("truck")
                },
                {
                    titulo: "Sucursal de destino",
                    izq: true,
                    der: true,
                    incompleto: true,
                    icon: fa("bank")
                },
                {
                    titulo: "En entrega",
                    izq: true,
                    der: true,
                    incompleto: true,
                    icon: fa("train")
                },
                {
                    titulo: "Entregado",
                    izq: true,
                    der: true,
                    incompleto: true,
                    icon: fa("handshake-o")
                }
            ];

        case models.StatusGuia.EnSucursalDestino:
            return [
                {
                    titulo: "Documentado",
                    izq: false,
                    der: true,
                    icon: fa("file")
                },
                {
                    titulo: "En transito",
                    izq: true,
                    der: true,
                    icon: fa("truck")
                },
                {
                    titulo: "Sucursal de destino",
                    izq: true,
                    der: false,
                    icon: fa("bank")
                },
                {
                    titulo: "En entrega",
                    izq: true,
                    der: true,
                    incompleto: true,
                    icon: fa("train")
                },
                {
                    titulo: "Entregado",
                    izq: true,
                    der: false,
                    incompleto: true,
                    icon: fa("handshake-o")
                }
            ];

        case models.StatusGuia.EnSucursalOrigen:
            return [
                {
                    titulo: "Documentado",
                    izq: false,
                    der: false,
                    icon: fa("file")
                },
                {
                    titulo: "En transito",
                    izq: true,
                    der: true,
                    incompleto: true,
                    icon: fa("truck")
                },
                {
                    titulo: "Sucursal de destino",
                    izq: true,
                    der: true,
                    incompleto: true,
                    icon: fa("bank")
                },
                {
                    titulo: "En entrega",
                    izq: true,
                    der: true,
                    incompleto: true,
                    icon: fa("train")
                },
                {
                    titulo: "Entregado",
                    izq: true,
                    der: false,
                    incompleto: true,
                    icon: fa("handshake-o")
                }
            ];

        case models.StatusGuia.EnSucursalTrasbordo:
            return [
                {
                    titulo: "Documentado",
                    izq: false,
                    der: true,
                    icon: fa("file")
                },
                {
                    titulo: "En transito",
                    izq: true,
                    der: true,
                    icon: fa("truck")
                },
                {
                    titulo: "Sucursal de destino",
                    izq: true,
                    der: true,
                    incompleto: true,
                    icon: fa("bank")
                },
                {
                    titulo: "En entrega",
                    izq: true,
                    der: true,
                    incompleto: true,
                    icon: fa("train")
                },
                {
                    titulo: "Entregado",
                    izq: true,
                    der: false,
                    incompleto: true,
                    icon: fa("handshake-o")
                }
            ];

        case models.StatusGuia.EntregadaZonaExtendida:
        case models.StatusGuia.EntregadaDomicilio:
            return [
                {
                    titulo: "Documentado",
                    izq: false,
                    der: true,
                    icon: fa("file")
                },
                {
                    titulo: "En transito",
                    izq: true,
                    der: true,
                    icon: fa("truck")
                },
                {
                    titulo: "Sucursal de destino",
                    izq: true,
                    der: true,
                    icon: fa("bank")
                },
                {
                    titulo: "En entrega",
                    izq: true,
                    der: true,
                    icon: fa("train")
                },
                {
                    titulo: "Entregado",
                    izq: true,
                    der: false,
                    icon: fa("handshake-o")
                }
            ];

        case models.StatusGuia.EntregadaOcurre:
            return [
                {
                    titulo: "Documentado",
                    izq: false,
                    der: true,
                    icon: fa("file")
                },
                {
                    titulo: "En transito",
                    izq: true,
                    der: true,
                    icon: fa("truck")
                },
                {
                    titulo: "Sucursal de destino",
                    izq: true,
                    der: true,
                    icon: fa("bank")
                },
                {
                    titulo: "En entrega",
                    izq: true,
                    der: true,
                    icon: fa("train")
                },
                {
                    titulo: "Entregado",
                    izq: true,
                    der: false,
                    icon: fa("handshake-o")
                }
            ];

        case models.StatusGuia.EnViaje:
            return [
                {
                    titulo: "Documentado",
                    izq: false,
                    der: true,
                    icon: fa("file")
                },
                {
                    titulo: "En transito",
                    izq: true,
                    der: true,
                    icon: fa("truck")
                },
                {
                    titulo: "Sucursal de destino",
                    izq: true,
                    der: true,
                    incompleto: true,
                    icon: fa("bank")
                },
                {
                    titulo: "En entrega",
                    izq: true,
                    der: true,
                    incompleto: true,
                    icon: fa("train")
                },
                {
                    titulo: "Entregado",
                    izq: true,
                    der: false,
                    incompleto: true,
                    icon: fa("handshake-o")
                }
            ];
        case models.StatusGuia.EnViajeZE:
        case models.StatusGuia.EnViajeEAD:
            return [
                {
                    titulo: "Documentado",
                    izq: false,
                    der: true,
                    icon: fa("file")
                },
                {
                    titulo: "En transito",
                    izq: true,
                    der: true,
                    icon: fa("truck")
                },
                {
                    titulo: "Sucursal de destino",
                    izq: true,
                    der: true,
                    icon: fa("bank")
                },
                {
                    titulo: "En entrega",
                    izq: true,
                    der: true,
                    icon: fa("train")
                },
                {
                    titulo: "Entregado",
                    izq: true,
                    der: false,
                    incompleto: true,
                    icon: fa("handshake-o")
                }
            ];
        case models.StatusGuia.EnViajeEADIncompleta:
        case models.StatusGuia.EnViajeZEIncompleta:
            return [
                {
                    titulo: "Documentado",
                    izq: false,
                    der: true,
                    icon: fa("file")
                },
                {
                    titulo: "En transito",
                    izq: true,
                    der: true,
                    icon: fa("truck")
                },
                {
                    titulo: "Sucursal de destino",
                    izq: true,
                    der: true,
                    icon: fa("bank")
                },
                {
                    titulo: "En entrega",
                    izq: true,
                    der: true,
                    icon: fa("train")
                },
                {
                    titulo: "Entregado",
                    izq: true,
                    der: false,
                    cancelado: true,
                    icon: fa("handshake-o")
                }
            ];
        case models.StatusGuia.EntregaZERechazada:
        case models.StatusGuia.EnViajeEADRechazada:
            return [
                {
                    titulo: "Documentado",
                    izq: false,
                    der: true,
                    icon: fa("file")
                },
                {
                    titulo: "En transito",
                    izq: true,
                    der: true,
                    icon: fa("truck")
                },
                {
                    titulo: "Sucursal de destino",
                    izq: true,
                    der: true,
                    icon: fa("bank")
                },
                {
                    titulo: "En entrega",
                    izq: true,
                    der: true,
                    icon: fa("train")
                },
                {
                    titulo: "Entregado",
                    izq: true,
                    der: false,
                    cancelado: true,
                    icon: fa("handshake-o")
                }
            ];
        case models.StatusGuia.RecoleccionPendiente:
            return [
                {
                    titulo: "Documentado",
                    izq: false,
                    der: false,
                    icon: fa("file")
                },
                {
                    titulo: "En transito",
                    izq: true,
                    der: true,
                    incompleto: true,
                    icon: fa("truck")
                },
                {
                    titulo: "Sucursal de destino",
                    izq: true,
                    der: true,
                    incompleto: true,
                    icon: fa("bank")
                },
                {
                    titulo: "En entrega",
                    izq: true,
                    der: true,
                    incompleto: true,
                    icon: fa("train")
                },
                {
                    titulo: "Entregado",
                    izq: true,
                    der: false,
                    incompleto: true,
                    icon: fa("handshake-o")
                }
            ];
        case models.StatusGuia.Cancelada:
            return [
                {
                    titulo: "Documentado",
                    izq: false,
                    der: true,
                    cancelado: true,
                    icon: fa("file")
                },
                {
                    titulo: "En transito",
                    izq: true,
                    der: true,
                    cancelado: true,
                    icon: fa("truck")
                },
                {
                    titulo: "Sucursal de destino",
                    izq: true,
                    der: true,
                    cancelado: true,
                    icon: fa("bank")
                },
                {
                    titulo: "En entrega",
                    izq: true,
                    der: true,
                    cancelado: true,
                    icon: fa("train")
                },
                {
                    titulo: "Entregado",
                    izq: true,
                    der: false,
                    cancelado: true,
                    icon: fa("handshake-o")
                }
            ];
        case models.StatusGuia.Invalido:
            return [
                {
                    titulo: "Documentado",
                    izq: false,
                    der: true,
                    cancelado: true,
                    icon: fa("file")
                },
                {
                    titulo: "En transito",
                    izq: true,
                    der: true,
                    cancelado: true,
                    icon: fa("truck")
                },
                {
                    titulo: "Sucursal de destino",
                    izq: true,
                    der: true,
                    cancelado: true,
                    icon: fa("bank")
                },
                {
                    titulo: "En entrega",
                    izq: true,
                    der: true,
                    cancelado: true,
                    icon: fa("train")
                },
                {
                    titulo: "Entregado",
                    izq: true,
                    der: false,
                    cancelado: true,
                    icon: fa("handshake-o")
                }
            ];
        default:
            return assertUnreachable(x);
    }
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/rastreo/estados.tsx